<template>
	<div class="loader" :style="{'width': width, 'height': height}"></div>
</template>

<script>
    export default {
        name: "Loading",
		props: {
        	width: {
        		type: String,
				default: '80px'
			},
			height: {
				type: String,
				default: '80px'
			}
        }
    }
</script>

<style scoped>
	.loader {
		position: absolute;
		left: 44%;
		top: 2%;
		z-index: 1;
		border: 6px solid #f3f3f3;
		border-radius: 50%;
		border-top: 6px solid #0092D3;
		border-bottom: 6px solid #0092D3;
		width: 60px;
		height: 60px;
		-webkit-animation: spin 1.6s linear infinite;
		animation: spin 1.6s linear infinite;
	}

	@-webkit-keyframes spin {
		0% { -webkit-transform: rotate(0deg); }
		100% { -webkit-transform: rotate(360deg); }
	}

	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
</style>
